<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-10 md:col-offset-1">
      <p-panel header="{{ 'GRUPO.LBL_GRUPOS' | translate}}" >
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GRUPO.LBL_CODIGO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{grupo.codigo}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GRUPO.LBL_NOMBRE' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{grupo.nombre}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GRUPO.LBL_GERENTEOFICINA' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{grupo.nombreUsuario}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GRUPO.LBL_HABILITADO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{grupo.indicadorHabilitado ? 'Si': 'No'}}</strong></label>
        </div>
      </p-panel>
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-10 md:col-offset-1">
      <p-panel header="{{ 'GRUPO.LBL_ZONA' | translate}}">
        <p-table [columns]="columnas"
                 [value]="gruposZonas" selectionMode="single" dataKey="idZona"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.codigoZona}}</td>
              <td>{{row.nombreZona}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar()"></button>
    </div>
  </div>
</div>
